import Vue from 'vue'
import Router from 'vue-router'
import VueMeta from 'vue-meta'

import Homepage from '../pages/Homepage'

Vue.use(VueMeta);
Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        { path: '/', component: Homepage, name: 'Homepage' },
    ],
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
})
